import { ChangeEvent, FC, useState } from 'react'
import alert from '../assets/alert.svg'

type ModalInputProps = {
  value: string
  error?: string
  labeledBy: string
  onChange: (e: ChangeEvent<HTMLInputElement>) => void
}

const ModalInput: FC<ModalInputProps> = ({
  value,
  onChange,
  labeledBy,
  error,
}) => {
  const [focused, setFocused] = useState(false)

  return (
    <>
      <div
        className={`${
          focused ? 'border-primaryBlue' : 'border-transparent'
        } border-2 mt-px p-0.5 rounded-xl w-60`}
      >
        <input
          className="border border-toggleGrey py-1.5 px-2 w-full rounded-lg text-sm focus:outline-none"
          type="text"
          aria-labelledby={labeledBy}
          value={value}
          autoFocus={true}
          onFocus={() => {
            setFocused(true)
          }}
          onBlur={() => {
            setFocused(false)
          }}
          onChange={onChange}
        />
      </div>
      {error && (
        <p className="text-warningRed text-xs pl-1">
          <img alt="" src={alert} className="inline-block pr-2" />
          {error}
        </p>
      )}
    </>
  )
}

export default ModalInput
